var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "omni-sidebar-item"
  }, [_vm.item.to ? [_c('RouterLink', {
    staticClass: "omni-sidebar-link",
    attrs: {
      "to": _vm.item.to
    },
    on: {
      "click": function ($event) {
        _vm.activeItem = _vm.item;
      }
    }
  }, [_c('span', {
    staticClass: "omni-sidebar-label"
  }, [_vm._v(" " + _vm._s(_vm.item.title) + " ")])])] : [_c('span', {
    staticClass: "omni-sidebar-heading"
  }, [_vm._v(" " + _vm._s(_vm.item.title) + " ")])], _vm.item.children ? _c('ul', _vm._l(_vm.item.children, function (child, index) {
    return _c('OmniSidebarItem', {
      key: index,
      attrs: {
        "item": child
      }
    });
  }), 1) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }